<template>
  <div class="device-detail-record">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-radio-group v-model="tabIndex" @change="dataTimes = ''">
            <el-radio-button :label="0">{{ $t('dms_device_detail_record.wei_xiu_ji_lu') }}</el-radio-button>
            <el-radio-button :label="1">{{ $t('dms_device_detail_record.ljghjl') }}</el-radio-button>
            <el-radio-button :label="2">{{ $t('dms_device_detail_record.bao_yang_ji_lu') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <repair-records v-if="tabIndex === 0" :times="dataTimes" :deviceInfo="deviceInfo" ref="repair"></repair-records>
    <replace-records v-if="tabIndex === 1" :times="dataTimes" :deviceInfo="deviceInfo" ref="replace"></replace-records>
    <maintenance-records v-if="tabIndex === 2" :times="dataTimes" :deviceInfo="deviceInfo" ref="maintenance"></maintenance-records>
  </div>
</template>

<script>
import repairRecords from './device_detail_record_repair_records.vue';
import replaceRecords from './device_detail_record_parts_replace_records.vue';
import maintenanceRecords from './device_detail_record_maintenance_records.vue';

export default {
  components: {
    maintenanceRecords,
    repairRecords,
    replaceRecords,
  },
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tabIndex: 0,
      dataTimes: '',
    };
  },
  mounted() {
  },
  methods: {
    dateChangeHandler() {
      const refList = ['maintenance', 'repair', 'replace'];
      const refName = refList[this.tabIndex];
      this.$nextTick(() => {
        this.$refs[refName].getTableList('init');
      });
    },
  },
};
</script>

<style lang="scss">
.device-detail-record {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 24px 24px;

  .el-form-item {
    margin-right: 0;
  }
}
</style>
